import * as Paginator from "react-bootstrap-table2-paginator";

import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { Field, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import ToolkitProvider, {
  CSVExport,
  Search,
} from "react-bootstrap-table2-toolkit";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import {
  faDownload,
  faPlus,
  faSearch,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import {
  getFieldWorkOrderDetailsLExcel,
  getFieldWorkOrderDetailsLPDF,
  getFieldWorkOrderExcelDownload,
  getInstallationEntryByDate,
  getInstallationPdfDownload,
  getWorkOrderInstallationList,
  getinstallationDispenserSerialNumber,
} from "../../Service/AllWorkOrderInstallationAPI";

import BootstrapTable from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Pagination from "react-bootstrap-table2-paginator";
import Select from "react-select";
import fileSaver from "file-saver";
import { getWorkOrderNoDropDown } from "../../Service/AllWorkOrder";
import { getWorkOrderNoWiseDispenser } from "../../Service/AllDispatchAPI";
import moment from "moment";
import swal from "sweetalert";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

export default () => {
  const { SearchBar } = Search;
  const { ExportCSVButton } = CSVExport;
  const selectRow = {
    mode: "checkbox",
  };

  // --- state ---
  const [entries, setEntries] = useState([]); 
  const [show, setShow] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [pageNo, setPageNo] = useState(0);
  const [workOrderNo, setWorkOrderNo] = useState([]);
  const [selectedWorkOrderNo, setSelectedWorkOrderNo] = useState("");
  const [dispenserNo, setDispenserNo] = useState([]);
  const [status, setStatus] = useState("ready to install");
  const [isLoaded, setisLoaded] = useState(false);
  const [searchDispenserSerialNumber, setSearchDispenserSerialNumber] = useState("");
  const [searchPerformed, setSearchPerformed] = useState(false);

  // --- pagination state ---
  const [state, setState] = useState({});
  const [currentPage, setcurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [totaloffset, setTotaloffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  // Function call to hide and show
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // helper to add serial numbers based on offset
  const addSerialNumbers = (arr = [], offset = 0) => {
    if (!Array.isArray(arr)) return [];
    return arr.map((item, index) => ({ ...item, id: offset + index + 1 }));
  };

  useEffect(() => {
    // initial load
    getInstallation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // update page change handler
  const handlePageChange = async (page) => {
    // page is 1-based from paginator
    const selectedPage = page - 1;
    setisLoaded(true);
    setEntries([]); // clear current entries while loading

    if (!fromDate && !toDate) {
      try {
        const role = sessionStorage.getItem("role");
        const fkUserId = sessionStorage.getItem("pkUserId");
        const token = sessionStorage.getItem("token");
        const headers = { Authorization: `Bearer ${token}` };

        const result = await getWorkOrderInstallationList(
          selectedPage,
          "installation",
          fkUserId,
          role,
          headers
        );

        const data = result?.data?.content || [];
        const totalSize = result?.data?.pageable?.offset || 0;
        const totalElements = result?.data?.totalElements || 0;
        const totalPages = result?.data?.totalPages || 0;

        if (data.length > 0) {
          const updated = addSerialNumbers(data, totalSize);
          setEntries(updated);
          setPageCount(totalPages);
          setTotaloffset(totalSize);
          setTotalCount(totalElements);
        } else {
          setEntries([]);
          setPageCount(0);
          setTotalCount(0);
          // swal("Sorry", "Installation Data is not present", "warning");
        }
      } catch (error) {
        console.error("Error", error);
        // swal("Failed", "Something went wrong while fetching data", "error");
      } finally {
        setisLoaded(false);
      }
    } else if (fromDate && toDate) {
      try {
        const result = await getInstallationEntryByDate(
          selectedPage,
          moment(fromDate).format("YYYY-MM-DD"),
          moment(toDate).format("YYYY-MM-DD")
        );

        const data = result?.data?.content || [];
        const totalSize = result?.data?.pageable?.offset || 0;
        const totalElements = result?.data?.totalElements || 0;
        const totalPages = result?.data?.totalPages || 0;

        if (data.length > 0) {
          const updated = addSerialNumbers(data, totalSize);
          setEntries(updated);
          setTotaloffset(totalSize);
          setTotalCount(totalElements);
          setPageCount(totalPages);
        } else {
          setEntries([]);
          setPageCount(0);
          setTotalCount(0);
          swal(
            "Sorry",
            "Work order installation data is not present for selected date",
            "warning"
          );
        }
      } catch (error) {
        console.error("Get Field Issue Error", error);
        swal("Failed", "Something went wrong while fetching date-wise data", "error");
      } finally {
        setisLoaded(false);
      }
    } else {
      setisLoaded(false);
      swal("Failed", "Please select date", "error");
    }
  };

  // Function declaration of get installation list
  const getInstallation = async () => {
    try {
      setisLoaded(true);
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };

      const result = await getWorkOrderInstallationList(
        currentPage,
        "installation",
        fkUserId,
        role,
        headers
      );

      console.log("Work Order Installation Result List", result?.data);

      const data = result?.data?.content || [];
      const totalElements = result?.data?.totalElements || 0;
      const totalPages = result?.data?.totalPages || 0;
      const totalSize = result?.data?.pageable?.offset || 0;

      if (data.length > 0) {
        const updated = addSerialNumbers(data, totalSize);
        setEntries(updated);
        setPageCount(totalPages);
        setTotalCount(totalElements);
        setTotaloffset(totalSize);
      } else {
        setEntries([]);
        setPageCount(0);
        setTotalCount(0);
        setTotaloffset(0);
        // swal("Sorry", "Work order installation data is not present", "warning");
      }
    } catch (error) {
      console.log("Work Order Installation Error", error);
      // swal("Failed", "Something went wrong please check your internet", "error");
    } finally {
      setisLoaded(false);
    }
  };

  const handleFromDateChange = (date) => {
    setFromDate(date);
    if (toDate && date > toDate) {
      setToDate(null);
    }
  };

  const handleToDateChange = (date) => {
    if (fromDate && date < fromDate) {
      swal('Invalid Date', 'The "To" date cannot be before the "From" date.', 'warning');
      setToDate(null);
    } else {
      setToDate(date);
    }
  };

  const getInstallationListByDate = async () => {
    try {
      setisLoaded(true);
      if (fromDate && toDate) {
        const result = await getInstallationEntryByDate(
          currentPage,
          moment(fromDate).format("YYYY-MM-DD"),
          moment(toDate).format("YYYY-MM-DD")
        );

        const data = result?.data?.content || [];
        const totalElements = result?.data?.totalElements || 0;
        const totalPages = result?.data?.totalPages || 0;
        const totalSize = result?.data?.pageable?.offset || 0;

        if (data.length > 0) {
          const updated = addSerialNumbers(data, totalSize);
          setEntries(updated);
          setPageCount(totalPages);
          setTotalCount(totalElements);
          setTotaloffset(totalSize);
        } else {
          setEntries([]);
          setPageCount(0);
          setTotalCount(0);
          swal(
            "Sorry",
            "Work order installation data is not present for selected date",
            "warning"
          );
        }
      } else {
        swal("Failed", "Please select date", "error");
      }
    } catch (error) {
      console.log("Get installation Entry Error", error);
      // swal("Failed", "Something went wrong please check your internet", "error");
    } finally {
      setisLoaded(false);
    }
  };

  const getFieldWorkOrderExcelList = async () => {
    if (fromDate && toDate) {
      try {
        await getFieldWorkOrderExcelDownload(
          moment(fromDate).format("YYYY-MM-DD"),
          moment(toDate).format("YYYY-MM-DD")
        );
      } catch (error) {
        console.log("getFieldWorkOrderExcelDownload error :-", error);
      }
    } else {
      try {
        await getFieldWorkOrderDetailsLExcel();
      } catch (error) {
        console.log("getFieldWorkOrderDetailsLExcel Installation error :-", error);
      }
    }
  };

  const getInstllationReportPdfDownload = async () => {
    if (fromDate && toDate) {
      try {
        setisLoaded(true);
        await getInstallationPdfDownload(
          moment(fromDate).format("YYYY-MM-DD"),
          moment(toDate).format("YYYY-MM-DD")
        );
      } catch (error) {
        console.log(error);
        // swal("Failed", "Something went wrong please check your internet", "error");
      } finally {
        setisLoaded(false);
      }
    } else {
      try {
        setisLoaded(true);
        await getFieldWorkOrderDetailsLPDF();
      } catch (error) {
        console.log("getFieldWorkOrderDetailsLExcel Installation error :-", error);
      } finally {
        setisLoaded(false);
      }
    }
  };

  const clearSearch = () => {
    setSearchDispenserSerialNumber('');
    setSearchPerformed(false);
    getInstallation();
  };

  const search = async () => {
    setSearchPerformed(true);
    if (!searchDispenserSerialNumber) {
      swal("Missing Serial Number", "Please enter the dispenser serial number", "warning").then(() => {
        clearSearch();
      });
      return;
    }

    try {
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      let jobType = ["installation"];
      const result = await getinstallationDispenserSerialNumber(currentPage, searchDispenserSerialNumber, headers, jobType);

      // API here returns array (as in your original code). If your API returns {data: [...]}, adjust accordingly.
      const data = Array.isArray(result) ? result : (result?.data || []);

      if (data.length > 0) {
        const updated = addSerialNumbers(data, 0);
        setEntries(updated);
        setPageCount(1);
        setTotalCount(data.length);
        setTotaloffset(0);
      } else {
        swal("No Data", "No records found for the given serial number", "info");
        setEntries([]);
        setPageCount(0);
        setTotalCount(0);
        setTotaloffset(0);
      }
    } catch (error) {
      console.error("Search error:", error);
      swal("Failed", "Failed to fetch data, please try again", "error");
    }
  };

  // Column heading of installation list
  const columns = [
    { dataField: "id", text: "Id" },
    {
      dataField: "status",
      text: "Installation WO Status",
      editable: false,
      headerAlign: "left",
      style: {
        textTransform: "capitalize",
        textAlign: 'center'
      },
    },
    {
      dataField: "workOrderSerialNo",
      text: "Installation WO Sr No",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "generateUniqueDispenserNo",
      text: "Dispenser Sr No",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "workOrderDate",
      text: "WO Created on",
      editable: false,
      headerAlign: "left",
      formatter: (cell) => {
        return <>{moment(cell).format("DD-MMM-YYYY")}</>;
      },
    },
    {
      dataField: "workOrderTime",
      text: "WO Created Time",
      editable: false,
      headerAlign: "left",
      formatter: (cell) => {
        return <>{moment(cell, "hh:mm A").format("hh:mm A")}</>;
      },
    },
    {
      dataField: "dispenserType",
      text: "Dispenser Config",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "customerName",
      text: "Customer Name",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "serviceEngineerName",
      text: "Field Man Name",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "serviceEngineerMobNo",
      text: "Field Man Mobile No",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "description",
      text: "description",
      editable: false,
      headerAlign: "left",
      formatter: (cell, row) => (
        <div className="tooltip-container">
          <div className="truncated-text">{cell}</div>
          {cell && cell.length > 20 && (
            <span className="tooltip-text">{row.description}</span>
          )}
        </div>
      )
    },
    {
      dataField: "installationAddress",
      text: "Site Address",
      editable: false,
      style: { textTransform: "capitalize" },
      formatter: (cell, row) => (
        <div className="tooltip-container">
          <div className="truncated-text">{cell}</div>
          {cell && cell.length > 20 && (
            <span className="tooltip-text">{row.installationAddress}</span>
          )}
        </div>
      )
    },
    {
      dataField: "jobPreference",
      text: "Communication Type",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "siteType",
      text: "Site Type",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "timeTaken",
      text: "Taken Time",
      headerAlign: "left",
    },
    {
      dataField: "whoDidIt",
      text: "Installation wo created by",
      headerAlign: "left",
      style: {
        textTransform: "capitalize",
        textAlign: 'center'
      },
    },
  ];

  // custom the pagination total
  const customTotal = (from, to, size) => (
    <div>
      Showing {totaloffset + from} to {totaloffset + to} of {size} entries
    </div>
  );

  // callback function when page was changing
  const customSizePerPage = (props) => {
    const { options, currentSizePerPage, onSizePerPageChange } = props;
    const onPageChange = (e) => {
      const page = e.target.value;
      onSizePerPageChange(page);
    };

    return (
      <>
        <Row>
          <Col xs="auto">
            <Form.Select
              value={currentSizePerPage}
              onChange={onPageChange}
              className="pe-5"
            >
              {options.map((o) => (
                <option key={o.page} value={o.page}>
                  {o.text}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col xs="auto" className="d-flex align-items-center">
            Entries per page
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
      <Formik
        initialValues={{
          firstname: "",
          lastname: "",
          companyname: "",
          mobileno: "",
          selectdesignation: "",
          email: "",
          country: "",
          state: "",
          address: "",
          city: "",
          desc: "",
        }}
        onSubmit={async (values) => {
          console.log(JSON.stringify(values, null, 2));
        }}
      >
        {(formik) => {
          return (
            <>
              <Row>
                <Col
                  md={{ span: 3, order: 1 }}
                  className="mb-3"
                  xs={{ order: 2 }}
                >
                  <div className="form-group">
                    <label>From Date</label>
                    <DatePicker
                      selected={fromDate}
                      onChange={handleFromDateChange}
                      dateFormat="dd-MMM-yyyy"
                      maxDate={new Date()}
                      className="form-control"
                      placeholderText="DD-MMM-YYYY"
                      showYearDropdown
                      scrollableYearDropdown
                    />
                  </div>
                </Col>
                <Col md={{ span: 3, order: 2 }} className="mb-3" xs={{ order: 3 }}>
                  <div className="form-group">
                    <label>To Date</label>
                    <DatePicker
                      selected={toDate}
                      onChange={handleToDateChange}
                      dateFormat="dd-MMM-yyyy"
                      minDate={fromDate}
                      maxDate={new Date()}
                      className="form-control"
                      placeholderText="DD-MMM-YYYY"
                      showYearDropdown
                      scrollableYearDropdown
                    />
                  </div>
                </Col>
                <Col
                  md={{ span: 3, order: 3 }}
                  className="mb-3"
                  xs={{ order: 4 }}
                >
                  <button
                    type="button"
                    className="btn btn-secondary mt-lg-4"
                    onClick={getInstallationListByDate}
                  >
                    <FontAwesomeIcon icon={faSearch} className="me-2" />
                    <span>Search By Date</span>{" "}
                  </button>
                </Col>

                <Col
                  md={{ span: 3, order: 4 }}
                  className="mt-4"
                  xs={{ order: 1 }}
                >
                  {/* <div className="newadd" align="right">
                    <Link to="installation" className="btn btn-secondary">
                      <FontAwesomeIcon icon={faPlus} className="me-2" />
                      <span>Create Installation WO</span>{" "}
                      
                    </Link>
                  </div> */}
                </Col>
              </Row>

              <ToolkitProvider
                keyField="id"
                search={true}
                columns={columns}
                data={entries}
                exportCSV={{ onlyExportFiltered: true, exportAll: true }}
              >
                {({ baseProps, searchProps, csvProps }) => (
                  <Paginator.PaginationProvider
                    pagination={Pagination({
                      custom: true,
                      disablePageTitle: true,
                      alwaysShowAllBtns: true,
                      totalSize: totalCount,
                      paginationTotalRenderer: customTotal,
                      onPageChange: handlePageChange,
                    })}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <Card>
                        <Col xs={12} md={6} className="p-2">
                          <h5 className="head ">Installation wo Entry list</h5>
                        </Col>
                        <div className="table-responsive py-2">
                          <Card.Header>
                            <Row>
                              <Col xs={12} md={6} className="py-1 md-3 d-flex ">

                                <input
                                  type="search"
                                  placeholder="Search by dispenser Sr No..."
                                  value={searchDispenserSerialNumber}
                                  onChange={(e) => setSearchDispenserSerialNumber(e.target.value)}
                                  className="form-control-alternative form-control searchinput "
                                  style={{ marginRight: '10px' }}
                                />

                                <button className="btn btn-secondary" onClick={searchPerformed ? clearSearch : search}>
                                  <FontAwesomeIcon icon={searchPerformed ? faTimes : faSearch} className="me-2" />
                                  <span>{searchPerformed ? "Clear Serial Number" : "Search By Serial Number"}</span>
                                </button>

                              </Col>

                              <Col
                                xs={12}
                                md={6}
                                className="d-flex justify-content-md-end py-1"
                              >
                                <button
                                  className="btn btn-secondary"
                                  onClick={getInstllationReportPdfDownload}
                                >
                                  <FontAwesomeIcon
                                    icon={faDownload}
                                    className="me-2"
                                  />
                                  <span>PDF</span>{" "}
                                </button>
                                <button
                                  className="btn btn-secondary mx-2"
                                  onClick={getFieldWorkOrderExcelList}
                                >
                                  <FontAwesomeIcon
                                    icon={faDownload}
                                    className="me-2"
                                  />
                                  <span>Excel</span>
                                </button>
                              </Col>
                            </Row>
                          </Card.Header>
                          {isLoaded ? (
                            <div className="text-center bg-black text-white"> Please wait installation data is loading ... </div>
                          ) : (
                            <BootstrapTable
                              {...baseProps}
                              {...paginationTableProps}
                              bodyClasses="border-0"
                              rowClasses="border-bottom"
                              classes="table-flush dataTable-table"
                              wrapperClasses="table-responsive"
                              filter={filterFactory()}
                              headerClasses="header-class"
                              hover
                              striped
                              remote={{ pagination: true }}
                              cellEdit={cellEditFactory({
                                mode: "click",
                                blurToSave: true,
                                afterSaveCell: (
                                  oldValue,
                                  newValue,
                                  row,
                                  column
                                ) => {
                                  console.log(oldValue, newValue, row, column);
                                },
                              })}
                            />
                          )}
                          <Card.Footer>
                            <Row>
                              <Col
                                xs={12}
                                md={6}
                                className="d-flex align-items-center py-1"
                              ></Col>
                              <Col
                                xs={12}
                                md={6}
                                className="d-flex justify-content-md-end align-items-center mb-0 py-1"
                              >
                                <Paginator.PaginationListStandalone
                                  {...paginationProps}
                                />
                              </Col>
                            </Row>
                          </Card.Footer>
                        </div>
                      </Card>
                    )}
                  </Paginator.PaginationProvider>
                )}
              </ToolkitProvider>
            </>
          );
        }}
      </Formik>
    </>
  );
};